import React, {useEffect, useState} from 'react';
import Credit from './component/credit'

function useWindowSize() {
  const getWindowSize = () => ({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
  })
  const [windowSize, setWindowSize] = useState(getWindowSize())
  const handleResize = () => {
      setWindowSize(getWindowSize())
  }
  useEffect(() => {
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
  })
  return windowSize
}

function App() {
  const clientSize = useWindowSize()
  useEffect(()=>{
    document.documentElement.style.fontSize = 10 * (clientSize.innerWidth / 960) + 'px';
  })

  return (
    <div id='app'>
      <Credit />
    </div>
  );
}

export default App;
